<div class="info">
  <i class="fal fa-info-circle"></i>
  <p>
    <ng-container i18n
      >Please enable each rental you would like to include in your {{ channelName }} feed.</ng-container
    >
    <br />
    <ng-container i18n
      >Rates for {{ channelName }} use the “Default” category or RateGenie only, further adjustments can be done via
      channel adjustment rules</ng-container
    >
  </p>
</div>
<div class="title-holder">
  <div class="row align-items-end">
    <div class="col-sm-3 title" i18n>Rental Connections</div>
    <div class="col-sm-9 btn-holder">
      <app-select-search
        class="w-auto ml-3"
        matTooltip="Only show rentals that specify the selected cities."
        i18n-matTooltip
        matTooltipPosition="above"
        id="rentals-filters-cities"
        floatLabel="never"
        [items]="cities$ | async"
        [ctrl]="citiesCtrl"
        placeholder="Rentals by Cities"
        i18n-placeholder
      ></app-select-search>
      <app-select-search
        class="w-auto ml-3"
        matTooltip="Only show rentals that specify the selected tags."
        i18n-matTooltip
        matTooltipPosition="above"
        id="rentals-filters-tags"
        floatLabel="never"
        [items]="tags$ | async"
        [ctrl]="tagsCtrl"
        placeholder="Rentals by Tags"
        i18n-placeholder
      ></app-select-search>
      <mat-form-field [floatLabel]="'never'" class="ml-2 p-0">
        <mat-select [formControl]="statusCtrl" placeholder="Connection Status" i18n-placeholder>
          <mat-option value="all" i18n>All</mat-option>
          <mat-option value="active" i18n>Active</mat-option>
          <mat-option value="inactive" i18n>Inactive</mat-option>
        </mat-select>
      </mat-form-field>
      <div dropdown class="btn-group ml-3" *ngIf="!(1 | isReadonlyRole)">
        <button dropdownToggle type="button" class="btn btn-cst-warning dropdown-toggle text-uppercase">
          <span class="fas fa-bolt"></span> <ng-container i18n>Actions</ng-container>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
          <li *ngIf="(rentalsWithoutTaxes$ | async)?.length === 0 || !taxesRequired">
            <button (click)="onEnableAll()" type="button" i18n>Enable All</button>
          </li>
          <li *ngIf="(rentalsWithoutTaxes$ | async)?.length > 0 && taxesRequired">
            <button
              matTooltip="Cannot enable all, some rentals are missing taxes. You can go to channel config and use Add Tax to add taxes in bulk, or open individual rental listings on the table below."
              i18n-matTooltip
              matTooltipPosition="left"
              matTooltipClass="text-center"
              type="button"
              i18n
            >
              Enable All
            </button>
          </li>
          <li>
            <button (click)="onDisableAll()" type="button" i18n>Disable All</button>
          </li>
          <li *ngIf="!anySelectedRentalMissingTaxes() || !taxesRequired">
            <button (click)="onEnableSelected()" type="button" i18n>Enable Selected</button>
          </li>
          <li *ngIf="anySelectedRentalMissingTaxes() && taxesRequired">
            <button
              matTooltip="Cannot enable selected, some rentals are missing taxes. You can go to channel config and use Add Tax to add taxes in bulk, or open individual rental listings on the table below."
              i18n-matTooltip
              matTooltipPosition="left"
              matTooltipClass="text-center"
              type="button"
              i18n
            >
              Enable Selected
            </button>
          </li>
          <li>
            <button (click)="onDisableSelected()" type="button" i18n>Disable Selected</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="container-box">
  <div class="details-box">
    <div class="table-holder table-responsive">
      <table class="table table-default table-striped">
        <mat-table matSort matSortActive="created" matSortDirection="desc" [dataSource]="dataSource">
          <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected(selection, renderedData)"
                [indeterminate]="selection.hasValue() && !isAllSelected(selection, renderedData)"
              >
              </mat-checkbox>
            </mat-header-cell>
            <mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)"
              >
              </mat-checkbox>
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="rental.name">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Linked Rental</mat-header-cell>
            <mat-cell *matCellDef="let element" class="text-truncate">
              <i
                *ngIf="!element?.rental?.taxes?.length && taxesRequired"
                [matTooltip]="
                  'Rental is missing taxes. ' + channelName + ' connection requires rental taxes to be set.'
                "
                matTooltipPosition="above"
                matTooltipClass="text-center"
                class="fal fa-exclamation-triangle"
              ></i>
              {{ element.rental?.name }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="date_enabled">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Date Enabled</mat-header-cell>
            <mat-cell *matCellDef="let element" class="text-truncate">
              {{ element.date_enabled | epoch }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="lastSync">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Last Sync</mat-header-cell>
            <mat-cell *matCellDef="let element" class="text-truncate">
              {{ element.last_sync | epoch }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="propertyId">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Channel ID</mat-header-cell>
            <mat-cell *matCellDef="let element" class="text-truncate">
              {{ element.channel_rental_id }}
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header i18n> Status</mat-header-cell>
            <mat-cell *matCellDef="let element" [class.click-disabled]="1 | isReadonlyRole">
              <ng-container *ngIf="element?.rental?.taxes?.length > 0">
                <mat-slide-toggle
                  (click)="$event.stopPropagation()"
                  [id]="element.id"
                  [checked]="element.status === 1"
                  (change)="onToggleStatus(element)"
                ></mat-slide-toggle>
              </ng-container>
              <ng-container *ngIf="!element?.rental?.taxes?.length">
                <mat-slide-toggle
                  #toggle
                  [checked]="false"
                  (click)="$event.stopPropagation(); onToggleStatus(element); toggle.toggle()"
                ></mat-slide-toggle>
              </ng-container>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="onRentalConfigDetails(row)"
            [class.row-danger]="!row?.rental?.taxes?.length && taxesRequired"
            class="clickable"
          ></mat-row>
        </mat-table>

        <ng-container *ngIf="isEmptyTable$ | async">
          <div class="box-alert d-flex justify-content-around">
            <div class="content" i18n>You haven't created any rentals on your account yet</div>
          </div>
        </ng-container>

        <mat-paginator
          [class.hidden]="isEmptyTable$ | async"
          [length]="dataSource?.data?.length"
          [pageSize]="10"
          [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
          [showFirstLastButtons]="true"
        >
        </mat-paginator>
      </table>
    </div>
  </div>
</div>
